import React, { useState } from "react";
import {
  RiBehanceFill,
  RiFacebookBoxFill,
  RiInstagramFill,
  RiLinkedinBoxFill,
  RiMailFill,
  RiMap2Fill,
  RiSkypeFill,
  RiTelegramFill,
  RiTwitterFill,
  RiWhatsappFill,
  RiYoutubeFill,
  RiSnapchatFill,
  RiGlobeFill,
  RiPhoneFill,
  RiMessage2Fill,
  RiAtFill,
  RiContactsBook2Line,
  RiMapPin2Line,
  RiGalleryLine,
  RiWechatFill,
  RiLineFill,
  RiEditLine,
  RiSave3Fill,
} from "react-icons/ri";
import { MdEmail } from "react-icons/md";
import {
  HiDeviceMobile,
  HiOfficeBuilding,
  HiLocationMarker,
} from "react-icons/hi";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { ImLocation2 } from "react-icons/im";
import { FaSuitcase, FaTiktok, FaUserCircle } from "react-icons/fa";
import {
  BsGlobe2,
  BsInfoCircleFill,
  BsFillTelephoneFill,
} from "react-icons/bs";
import { EyeOutlined } from "@ant-design/icons";
import { Button, Carousel, Col, Image, Input, Modal, Row } from "antd";
import vCardsJS from "vcards-js";
import { Domain } from "../config/API";
import { profileImgPlaceholder } from "../assets/images";
import { QRCode } from "react-qrcode-logo";
import Header from "../container/vCard/components/Header";

const EditSaveIcon = ({
  editKeys,
  currentKey,
  handleEditKeys,
  primaryColor,
}) => {
  return (
    <>
      {editKeys.includes(currentKey) ? (
        <RiSave3Fill
          className="heading-icon"
          style={{
            color: primaryColor,
            cursor: "pointer",
            marginLeft: "1rem",
          }}
          onClick={handleEditKeys}
        />
      ) : (
        <RiEditLine
          className="heading-icon"
          style={{
            color: primaryColor,
            cursor: "pointer",
            marginLeft: "1rem",
          }}
          onClick={handleEditKeys}
        />
      )}
    </>
  );
};

const PreviewVcard = ({
  selectedTheme,
  secondaryColor,
  primaryColor,
  profileImage,
  bgImage,
  fName,
  fNamePrefix,
  lNameSuffix,
  lName,
  mobile,
  mobile2,
  email,
  email2,
  jobTitle,
  company,
  phone,
  phone2,
  address,
  postalAddress,
  link,
  summary,
  webLinks,
  images,
  socialLinks,
  youtubeLinks,
  qrSetting,
  showQr,
  sectionOrder,
  setSectionOrder,
}) => {
  const getOnlyJpegName = (value) => {
    if (typeof value === "object" && value !== null) {
      return value.url.split("data/")[1];
    } else {
      return value;
    }
  };
  let vcfCard = vCardsJS();
  if (fName) vcfCard.firstName = fName;
  if (fNamePrefix) vcfCard.namePrefix = fNamePrefix;
  if (lNameSuffix) vcfCard.nameSuffix = lNameSuffix;
  if (lName) vcfCard.lastName = lName;
  if (email && !email2) vcfCard.workEmail = email;
  if (!email && email2) vcfCard.workEmail = email2;
  if (email && email2) vcfCard.workEmail = [email, email2];
  if (mobile && !mobile2) vcfCard.cellPhone = mobile;
  if (!mobile && mobile2) vcfCard.cellPhone = mobile2;
  if (mobile && mobile2) vcfCard.cellPhone = [mobile, mobile2];
  if (phone && !phone2) vcfCard.workPhone = phone;
  if (!phone && phone2) vcfCard.workPhone = phone2;
  if (phone && phone2) vcfCard.workPhone = [phone, phone2];

  if (jobTitle) vcfCard.title = jobTitle;
  if (company) vcfCard.organization = company;
  if (profileImage)
    vcfCard.photo.attachFromUrl(
      Domain + "/data/" + getOnlyJpegName(profileImage)
    );
  // if (address) vcfCard.workAddress.label = "Address";
  if (address) vcfCard.workAddress.street = address;
  vcfCard.version = "3.0";
  vcfCard.url = `${
    process.env.REACT_APP_DOMAIN_URL || "https://wavecodes.com.au"
  }/wc/${link}`;

  // download vcf card
  const downloadVcfFile = () => {
    const element = document.createElement("a");
    const file = new Blob([vcfCard.getFormattedString()], {
      type: "text/vcard",
    });
    element.href = URL.createObjectURL(file);
    element.download = fName + ".vcf";
    document.body.appendChild(element);
    element.click();
  };
  // const RenderField = (fieldName, value) => (
  //   <div className="field">
  //     <p style={{ fontSize: 12, color: "#808Ea7" }}>{fieldName}</p>
  //     <p style={{ color: "#141A22" }}>{value}</p>
  //   </div>
  // );
  const RenderIcons = (fieldName) => {
    const style = {
      size: "2rem",
    };
    const size = "1.5rem";
    switch (fieldName) {
      case "Name":
        return <FaUserCircle size={size} style={style} />;
      case "Mobile":
        return <HiDeviceMobile size={size} style={style} />;
      case "Mobile 2":
        return <HiDeviceMobile size={size} style={style} />;
      case "Phone":
        return <BsFillTelephoneFill size={size} style={style} />;
      case "Phone 2":
        return <BsFillTelephoneFill size={size} style={style} />;
      case "Email":
        return <MdEmail size={size} style={style} />;
      case "Email 2":
        return <MdEmail size={size} style={style} />;
      case "Job Title":
        return <FaSuitcase size={size} style={style} />;
      case "Company":
        return <HiOfficeBuilding size={size} style={style} />;
      default:
        return <></>;
    }
  };
  const RenderField = (fieldName, value) => (
    <Row
      style={{
        boxShadow: "0px 1px 7px rgba(0, 0, 0, 0.16)",
        margin: ".5rem 0",
        padding: ".5rem 0",
        borderRadius: "0.5rem",
      }}
    >
      <Col
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        span={4}
      >
        {RenderIcons(fieldName)}
      </Col>
      <Col
        span={20}
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <p
          style={{
            fontSize: 15,
            color: "#141A22",
            margin: ".5rem 0",
            fontWeight: "600",
          }}
        >
          {fieldName}
        </p>
        <p
          style={{
            fontSize: 15,
            color: "#141A22",
            margin: ".5rem 1rem .5rem 0rem",
            wordBreak: "break-all",
            textAlign: "left",
          }}
        >
          {value}
        </p>
      </Col>
    </Row>
  );
  const youtube_parser = (url) => {
    const regExp =
      /^https?:\/\/(?:www\.youtube(?:-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*&)?vi?=|&vi?=|\?(?:.*&)?vi?=)([^#&?\n/<>"']*)/i;
    const match = url.match(regExp);
    return match && match[1].length === 11 ? match[1] : false;
  };

  const [editKeys, setEditKeys] = useState([]);
  //   iamge Preview
  const [previewVisible, setPreviewVisible] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [imgData, setImgData] = useState(null);
  // social
  const renderSocialIcon = (name) => {
    switch (name) {
      case "facebook":
        return (
          <RiFacebookBoxFill
            style={{
              background: "white",
              color: "#4267B2",
              padding: "5px",
            }}
          />
        );
      case "instagram":
        return (
          <RiInstagramFill
            style={{ background: "white", color: "#E1306C", padding: "5px" }}
          />
        );
      case "linkedin":
        return (
          <RiLinkedinBoxFill
            style={{ background: "white", color: "#0072b1", padding: "5px" }}
          />
        );
      case "twitter":
        return (
          <RiTwitterFill
            style={{ background: "white", color: "#1DA1F2", padding: "5px" }}
          />
        );
      case "skype":
        return (
          <RiSkypeFill
            style={{ background: "white", color: "#00aff0", padding: "5px" }}
          />
        );
      case "behance":
        return (
          <RiBehanceFill
            style={{ background: "white", color: "#1769ff", padding: "5px" }}
          />
        );
      case "youtube":
        return (
          <RiYoutubeFill
            style={{ background: "white", color: "#FF0000", padding: "5px" }}
          />
        );
      case "maps":
        return (
          <RiMap2Fill
            style={{ background: "white", color: "#00ccd3", padding: "5px" }}
          />
        );
      case "mail":
        return (
          <RiMailFill
            style={{ background: "white", color: "#2B9BCF", padding: "5px" }}
          />
        );
      case "telegram":
        return (
          <RiTelegramFill
            style={{ background: "white", color: "#2AABEE", padding: "5px" }}
          />
        );
      case "tiktok":
        return (
          <FaTiktok
            style={{ background: "white", color: "#000000", padding: "5px" }}
          />
        );
      case "whatsapp":
        return (
          <RiWhatsappFill
            style={{ background: "white", color: "#25D366", padding: "5px" }}
          />
        );
      case "snapchat":
        return (
          <RiSnapchatFill
            style={{ background: "white", color: "#FFFC00", padding: "5px" }}
          />
        );
      case "wechat":
        return (
          <RiWechatFill
            style={{ background: "white", color: "#7BB32E", padding: "5px" }}
          />
        );
      case "line":
        return (
          <RiLineFill
            style={{ background: "white", color: "#06C755", padding: "5px" }}
          />
        );
      default:
        return (
          <RiGlobeFill
            style={{
              background: "white",
              color: secondaryColor,
              padding: "5px",
            }}
          />
        );
    }
  };

  // a little function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    // paddingTop: grid * 2,
    // margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? secondaryColor : "transparent",
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    // background: isDraggingOver ? "lightblue" : "lightgrey",
    // padding: grid,
  });
  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      sectionOrder,
      result.source.index,
      result.destination.index
    );

    setSectionOrder(items);
  };
  const handleHeaderText = (e, key) => {
    const existingSectionOrder = [...sectionOrder];
    for (let index = 0; index < sectionOrder.length; index++) {
      if (key.toString() === existingSectionOrder[index]?.key) {
        const toChangeSection = { ...existingSectionOrder[index] };
        const tempSectionOrder = {
          ...toChangeSection,
          header: e.target.value,
        };
        existingSectionOrder[index] = tempSectionOrder;
      }
    }
    setSectionOrder(existingSectionOrder);
  };
  const handleEditKeys = (key) => {
    let exitEditKeys = [...editKeys];
    if (exitEditKeys.includes(key)) {
      exitEditKeys = exitEditKeys.filter((item) => item !== key);
    } else {
      exitEditKeys.push(key);
    }
    setEditKeys(exitEditKeys);
  };
  return (
    <div className="vCard">
      <div className="vCard-container">
        <Header
          vCard={{
            selectedTheme: selectedTheme,
            sColor: secondaryColor,
            pColor: primaryColor,
            profileImage: getOnlyJpegName(profileImage),
            bgImage: getOnlyJpegName(bgImage),
            fName,
            fNamePrefix,
            lNameSuffix,
            lName,
            mobile,
            email,
            jobTitle,
            company,
            phone,
            address,
            socialLinks,
            webLinks,
          }}
          isPreview={true}
          downloadVcfFile={downloadVcfFile}
        />
        <div
          style={{
            backgroundColor: primaryColor,
            paddingBottom: "1rem",
          }}
        >
          {false && (
            <div className="body-container" style={{ paddingBottom: "1rem" }}>
              {/* Profile Image */}
              <img
                className="profile-image"
                src={profileImage ? profileImage : profileImgPlaceholder}
                alt=""
              />
              {/* username */}
              <h2 className="name mt-20">{`${
                fNamePrefix || ""
              } ${fName} ${lName} ${lNameSuffix || ""}`}</h2>
              {company && <h3 className="sub-info mt-23">{`${company}`}</h3>}
              {/* Direct Contact */}
              <div className="direct-contact">
                <a href={"tel:" + mobile}>
                  <RiPhoneFill style={{ color: secondaryColor }} />
                </a>

                <a href={"sms:" + mobile}>
                  <RiMessage2Fill style={{ color: secondaryColor }} />
                </a>
                {email && (
                  <a href={"mailto:" + email}>
                    <RiAtFill style={{ color: secondaryColor }} />
                  </a>
                )}
                {address && (
                  <a
                    href={"https://www.google.com/maps/search/" + address}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <ImLocation2 style={{ color: secondaryColor }} />
                  </a>
                )}
                <div
                  style={{
                    alignSelf: "center",
                    paddingRight: "4rem",
                    paddingLeft: "4rem",
                    justifyContent: "center",
                    alignContent: "center",
                    display: "flex",
                    flexWrap: "wrap",
                    flexDirection: "row",
                    alignItems: "stretch",
                  }}
                >
                  {socialLinks?.map((l) => {
                    return (
                      l?.link && (
                        <p
                          className="social-links"
                          onClick={() => {
                            window.open("https://" + l?.link, "_blank");
                          }}
                          key={l._id}
                        >
                          {renderSocialIcon(l?.name)}
                        </p>
                      )
                    );
                  })}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <Button
                      style={{
                        height: "2.5rem",
                        borderColor: secondaryColor,
                        color: secondaryColor,
                        marginTop: "1rem",
                        borderWidth: 0,
                        boxShadow: "3px 3px 3px 3px #88888a3a",
                      }}
                      shape="round"
                      size="middle"
                      onClick={downloadVcfFile}
                    >
                      Save My Contact
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={{
                    ...getListStyle(snapshot.isDraggingOver),
                    paddingTop: 24,
                  }}
                >
                  {sectionOrder.map((item, index) => (
                    <Draggable
                      key={item.key}
                      draggableId={item.key}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={{
                            ...getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            ),
                          }}
                        >
                          {item.key === "1" && (
                            <>
                              {/* card */}
                              <div className="card-container br-8 mb-24 p-10">
                                {/* card head */}
                                <div className="card-head">
                                  <div
                                    style={{
                                      display: "flex",
                                      flex: 1,
                                    }}
                                  />
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      flex: 5,
                                    }}
                                  >
                                    <RiContactsBook2Line
                                      className="heading-icon"
                                      style={{ color: primaryColor }}
                                    />
                                    {editKeys.includes(item?.key) ? (
                                      <Input
                                        style={{ borderRadius: ".5rem" }}
                                        placeholder="Contact"
                                        value={item?.header}
                                        onChange={(e) =>
                                          handleHeaderText(e, item.key)
                                        }
                                      />
                                    ) : (
                                      <h3
                                        className="heading-text"
                                        style={{ color: primaryColor }}
                                      >
                                        {item?.header}
                                      </h3>
                                    )}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flex: 1,
                                    }}
                                  >
                                    <EditSaveIcon
                                      currentKey={item.key}
                                      editKeys={editKeys}
                                      handleEditKeys={() => {
                                        handleEditKeys(item.key);
                                      }}
                                      primaryColor={primaryColor}
                                    />
                                  </div>
                                </div>
                                {/* contact body */}
                                <div>
                                  {/* name */}
                                  {RenderField(
                                    "Name",
                                    `${fNamePrefix || ""} ${fName}  ${
                                      lName && lName
                                    } ${lNameSuffix || ""}`
                                  )}
                                  {/* Mobile */}
                                  {RenderField(
                                    "Mobile",
                                    mobile ? mobile : "Your Mobile 1"
                                  )}
                                  {/* Mobile 2 */}
                                  {mobile2 &&
                                    RenderField(
                                      "Mobile 2",
                                      mobile2 ? mobile2 : "Your Mobile 2"
                                    )}
                                  {phone && RenderField("Phone", phone)}
                                  {phone2 && RenderField("Phone 2", phone2)}
                                  {/* Email */}
                                  {email && RenderField("Email", email)}
                                  {email2 && RenderField("Email 2", email2)}
                                  {/* JobTitle */}
                                  {jobTitle &&
                                    RenderField("Job Title", jobTitle)}
                                  {/* Company */}
                                  {company && RenderField("Company", company)}
                                  {(address || postalAddress) && (
                                    <>
                                      <div>
                                        {/* card head */}
                                        <div className="card-head">
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <RiMapPin2Line
                                              className="heading-icon"
                                              style={{ color: primaryColor }}
                                            />
                                            <h3
                                              className="heading-text"
                                              style={{ color: primaryColor }}
                                            >
                                              Location
                                            </h3>
                                          </div>
                                        </div>
                                      </div>
                                      <Col
                                        style={{
                                          boxShadow:
                                            "0px 1px 7px rgba(0, 0, 0, 0.16)",
                                          margin: ".5rem 0",
                                          padding: ".5rem 0",
                                          borderRadius: "0.5rem",
                                        }}
                                      >
                                        {/* adress */}

                                        {address && (
                                          <Row
                                            style={{
                                              margin: "1rem 0",
                                            }}
                                          >
                                            <Col
                                              span={4}
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <HiLocationMarker className="heading-icon" />
                                            </Col>
                                            <Col span={20}>
                                              <Row>
                                                <p
                                                  style={{
                                                    color: "black",
                                                    fontWeight: "bold",
                                                    paddingRight: "1rem",
                                                  }}
                                                >
                                                  Address
                                                </p>
                                              </Row>
                                              <Row>
                                                <p
                                                  style={{
                                                    color: "black",
                                                    wordBreak: "break-all",
                                                    cursor: "pointer",
                                                    textAlign: "left",
                                                    margin:
                                                      ".5rem 1rem .5rem 0rem",
                                                  }}
                                                  onClick={() =>
                                                    window.open(
                                                      "https://www.google.com/maps/search/" +
                                                        address,
                                                      "_blank"
                                                    )
                                                  }
                                                >
                                                  {address}
                                                </p>
                                              </Row>
                                            </Col>
                                          </Row>
                                        )}
                                        {/* card body */}
                                        {postalAddress && (
                                          <Row style={{ margin: "1rem 0" }}>
                                            <Col
                                              span={4}
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <HiLocationMarker className="heading-icon" />
                                            </Col>
                                            <Col
                                              span={20}
                                              style={{ paddingRight: "1rem" }}
                                            >
                                              <Row>
                                                <p
                                                  style={{
                                                    color: "black",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Postal Address
                                                </p>
                                              </Row>
                                              <Row>
                                                <p
                                                  style={{
                                                    color: "black",
                                                    wordBreak: "break-all",
                                                    textAlign: "left",
                                                    margin:
                                                      ".5rem 1rem .5rem 0rem",
                                                  }}
                                                >
                                                  {postalAddress}
                                                </p>
                                              </Row>
                                            </Col>
                                          </Row>
                                        )}
                                      </Col>
                                    </>
                                  )}
                                </div>
                              </div>
                            </>
                          )}

                          {/* WebLinks */}
                          {webLinks?.length > 0 && (
                            <>
                              {item.key === "2" && (
                                <div className="card-container br-8 mb-24 p-20">
                                  {/* card head */}
                                  <div className="card-head">
                                    <div
                                      style={{
                                        display: "flex",
                                        flex: 1,
                                      }}
                                    />
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flex: 5,
                                      }}
                                    >
                                      <BsGlobe2
                                        className="heading-icon"
                                        style={{ color: primaryColor }}
                                      />
                                      {editKeys.includes(item?.key) ? (
                                        <Input
                                          style={{ borderRadius: ".5rem" }}
                                          placeholder="Web Links"
                                          value={item?.header}
                                          onChange={(e) =>
                                            handleHeaderText(e, item.key)
                                          }
                                        />
                                      ) : (
                                        <h3
                                          className="heading-text"
                                          style={{ color: primaryColor }}
                                        >
                                          {item?.header}
                                        </h3>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flex: 1,
                                      }}
                                    >
                                      <EditSaveIcon
                                        currentKey={item.key}
                                        editKeys={editKeys}
                                        handleEditKeys={() => {
                                          handleEditKeys(item.key);
                                        }}
                                        primaryColor={primaryColor}
                                      />
                                    </div>
                                  </div>
                                  {/* card body */}
                                  <div
                                    className="card-body "
                                    style={{
                                      marginTop: 10,
                                    }}
                                  >
                                    {webLinks.map((l, i) => (
                                      <Row
                                        onClick={() =>
                                          window.open(
                                            "https://" + l?.link,
                                            "_blank"
                                          )
                                        }
                                        key={i}
                                        style={{
                                          margin: "1rem",
                                          display: "flex",
                                          flexDirection: "row",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Col span={2}>
                                          {l.icon ? (
                                            <i
                                              className={`fas fa-${l.icon}`}
                                              style={{
                                                color: primaryColor,
                                                fontSize: "1.2rem",
                                              }}
                                            />
                                          ) : l.image ? (
                                            <img
                                              src={Domain + "/data/" + l?.image}
                                              style={{
                                                width: "1.2rem",
                                                height: "1.2rem",
                                              }}
                                              alt="icon"
                                            />
                                          ) : (
                                            <BsGlobe2
                                              style={{
                                                color: primaryColor,
                                                fontSize: "1.2rem",
                                              }}
                                            />
                                          )}
                                        </Col>
                                        <Col>
                                          <p style={{ marginLeft: "1rem" }}>
                                            {l?.name}
                                          </p>
                                        </Col>
                                      </Row>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </>
                          )}

                          {/* Summary */}
                          {summary && (
                            <>
                              {item.key === "3" && (
                                <div className="card-container br-8 mb-24 p-20">
                                  {/* card head */}
                                  <div className="card-head">
                                    <div
                                      style={{
                                        display: "flex",
                                        flex: 1,
                                      }}
                                    />
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flex: 5,
                                      }}
                                    >
                                      <BsInfoCircleFill
                                        className="heading-icon"
                                        style={{ color: primaryColor }}
                                      />
                                      {editKeys.includes(item?.key) ? (
                                        <Input
                                          style={{ borderRadius: ".5rem" }}
                                          placeholder="About Us"
                                          value={item?.header}
                                          onChange={(e) =>
                                            handleHeaderText(e, item.key)
                                          }
                                        />
                                      ) : (
                                        <h3
                                          className="heading-text"
                                          style={{ color: primaryColor }}
                                        >
                                          {item?.header}
                                        </h3>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flex: 1,
                                      }}
                                    >
                                      <EditSaveIcon
                                        currentKey={item.key}
                                        editKeys={editKeys}
                                        handleEditKeys={() => {
                                          handleEditKeys(item.key);
                                        }}
                                        primaryColor={primaryColor}
                                      />
                                    </div>
                                  </div>
                                  {/* card body */}
                                  <div
                                    className="card-body"
                                    style={{
                                      marginTop: 10,
                                      textAlign: "left",
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: summary,
                                    }}
                                  ></div>
                                </div>
                              )}
                            </>
                          )}
                          {showQr === true && (
                            <>
                              {item.key === "4" && (
                                <div className="card-container br-8 mb-24 p-20">
                                  <div className="card-head">
                                    <div
                                      style={{
                                        display: "flex",
                                        flex: 1,
                                      }}
                                    />
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flex: 5,
                                      }}
                                    >
                                      <BsInfoCircleFill
                                        className="heading-icon"
                                        style={{ color: primaryColor }}
                                      />
                                      {editKeys.includes(item?.key) ? (
                                        <Input
                                          style={{ borderRadius: ".5rem" }}
                                          placeholder="SCAN QR CODE"
                                          value={item?.header}
                                          onChange={(e) =>
                                            handleHeaderText(e, item.key)
                                          }
                                        />
                                      ) : (
                                        <h3
                                          className="heading-text"
                                          style={{ color: primaryColor }}
                                        >
                                          {item?.header}
                                        </h3>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flex: 1,
                                      }}
                                    >
                                      <EditSaveIcon
                                        currentKey={item.key}
                                        editKeys={editKeys}
                                        handleEditKeys={() => {
                                          handleEditKeys(item.key);
                                        }}
                                        primaryColor={primaryColor}
                                      />
                                    </div>
                                  </div>
                                  <QRCode
                                    size={qrSetting.size}
                                    value={`${
                                      process.env.REACT_APP_DOMAIN_URL ||
                                      "https://wavecodes.com.au"
                                    }/wc/${link}`}
                                    quietZone={qrSetting.quietZone}
                                    fgColor={qrSetting.fgColor}
                                    bgColor={qrSetting.bgColor}
                                    ecLevel={qrSetting.ecLevel}
                                    qrStyle={qrSetting.qrStyle}
                                    eyeRadius={qrSetting.eyeRadius}
                                    logoImage={`${Domain}/data/${qrSetting?.logoImage}`}
                                    logoWidth={qrSetting.logoWidth}
                                    logoHeight={qrSetting.logoHeight}
                                    logoOpacity={qrSetting.logoOpacity}
                                  />
                                </div>
                              )}
                            </>
                          )}

                          {images?.length > 0 && (
                            <>
                              {item.key === "5" && (
                                <div className="card-container br-8 mb-24 p-20">
                                  {/* card head */}
                                  <div className="card-head">
                                    <div
                                      style={{
                                        display: "flex",
                                        flex: 1,
                                      }}
                                    />
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flex: 5,
                                      }}
                                    >
                                      <RiGalleryLine
                                        className="heading-icon"
                                        style={{ color: primaryColor }}
                                      />
                                      {editKeys.includes(item?.key) ? (
                                        <Input
                                          style={{ borderRadius: ".5rem" }}
                                          placeholder="Gallery"
                                          value={item?.header}
                                          onChange={(e) =>
                                            handleHeaderText(e, item.key)
                                          }
                                        />
                                      ) : (
                                        <h3
                                          className="heading-text"
                                          style={{ color: primaryColor }}
                                        >
                                          {item?.header}
                                        </h3>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flex: 1,
                                      }}
                                    >
                                      <EditSaveIcon
                                        currentKey={item.key}
                                        editKeys={editKeys}
                                        handleEditKeys={() => {
                                          handleEditKeys(item.key);
                                        }}
                                        primaryColor={primaryColor}
                                      />
                                    </div>
                                  </div>
                                  {/* card body */}
                                  <Carousel autoplay dotPosition="bottom">
                                    {images.map((img, i) => {
                                      return (
                                        <div key={i}>
                                          <div
                                            style={{
                                              width: "100%",
                                              height: 300,
                                              borderRadius: 8,
                                              marginTop: 10,
                                              background: `url(${img.url})`,
                                              backgroundSize: "cover",
                                              backgroundRepeat: "no-repeat",
                                              backgroundPosition: "center",
                                            }}
                                            onMouseEnter={() =>
                                              setPreviewVisible(true)
                                            }
                                            onMouseLeave={() =>
                                              setPreviewVisible(false)
                                            }
                                          >
                                            <div
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                display: previewVisible
                                                  ? "flex"
                                                  : "none",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                color: "#FFF",
                                                background: "#00000050",
                                                borderRadius: 8,
                                                boxShadow:
                                                  "inset -1px 5px 80px 4px rgba(0,0,0,0.2)",
                                                cursor: "pointer",
                                                transition:
                                                  "all 0.3s ease-in-out",
                                              }}
                                              onClick={() => {
                                                setImgData(img?.url);
                                                setIsPreview(true);
                                              }}
                                            >
                                              <EyeOutlined
                                                style={{ paddingRight: 5 }}
                                              />{" "}
                                              Preview
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </Carousel>
                                </div>
                              )}
                            </>
                          )}

                          {youtubeLinks?.length > 0 && (
                            <>
                              {item.key === "6" && (
                                <div className="card-container br-8 mb-24 p-20">
                                  {/* card head */}
                                  <div className="card-head">
                                    <div
                                      style={{
                                        display: "flex",
                                        flex: 1,
                                      }}
                                    />
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flex: 5,
                                      }}
                                    >
                                      <RiGalleryLine
                                        className="heading-icon"
                                        style={{ color: primaryColor }}
                                      />
                                      {editKeys.includes(item?.key) ? (
                                        <Input
                                          style={{ borderRadius: ".5rem" }}
                                          placeholder="Gallery"
                                          value={item?.header}
                                          onChange={(e) =>
                                            handleHeaderText(e, item.key)
                                          }
                                        />
                                      ) : (
                                        <h3
                                          className="heading-text"
                                          style={{ color: primaryColor }}
                                        >
                                          {item?.header}
                                        </h3>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flex: 1,
                                      }}
                                    >
                                      <EditSaveIcon
                                        currentKey={item.key}
                                        editKeys={editKeys}
                                        handleEditKeys={() => {
                                          handleEditKeys(item.key);
                                        }}
                                        primaryColor={primaryColor}
                                      />
                                    </div>
                                  </div>
                                  {/* card body */}
                                  <Carousel autoplay dotPosition="bottom">
                                    {youtubeLinks.map((item, i) => {
                                      return (
                                        <div key={i}>
                                          <div
                                            style={{
                                              width: "100%",
                                              height: 300,
                                              borderRadius: 8,
                                              marginTop: 10,
                                              backgroundSize: "cover",
                                              backgroundRepeat: "no-repeat",
                                              backgroundPosition: "center",
                                            }}
                                            onMouseEnter={() =>
                                              setPreviewVisible(true)
                                            }
                                            onMouseLeave={() =>
                                              setPreviewVisible(false)
                                            }
                                          >
                                            <iframe
                                              width={"100%"}
                                              height={"100%"}
                                              src={`https://www.youtube.com/embed/${youtube_parser(
                                                item.link
                                              )}`}
                                              title="Embedded youtube"
                                              frameBorder="0"
                                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                              allowFullScreen
                                            />
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </Carousel>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>
      <Modal
        title="Image Preview"
        visible={isPreview}
        onCancel={() => setIsPreview(false)}
        footer={null}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Image src={imgData} preview={false} draggable={false} />
        </div>
      </Modal>
    </div>
  );
};

export default PreviewVcard;
